import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import DentalRequestDetails from './Modals/DentalRequestsDetails';
import LoadingComponent from '../common/LoadingComponent';
import { getDentalRequests } from '../../services/api/cashless-dentals';

const DentalRequestDetailsWrapper = () => {
    const { reqId } = useParams(); // Extract the reqId from the route
    const [details, setDetails] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();

    useEffect(() => {
        if (reqId) {
            getDentalRequests(reqId)
                .then((response) => {
                    if (response) {
                        setDetails({
                            requestId: reqId,
                            showRequestDetails: true,
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error fetching request details:', error);
                    toast.error('Failed to fetch vaccination request details.');
                    history.push('/'); // Redirect to home or a fallback route
                })
                .finally(() => setIsLoading(false));
        }
    }, [reqId, history]);

    if (isLoading) {
        return <LoadingComponent color="black" />;
    }

    return (
        <DentalRequestDetails
            details={details}
            isOpen={true}
            onClose={() => history.push('/')} // Close and redirect back to home
        />
    );
};

export default DentalRequestDetailsWrapper;
